<template>
  <div class="HomePage h-full w-full text-lg">
    <DropMenu></DropMenu>
    <!-- top -->
    <TopMenu ref="TopMenu"></TopMenu>
    <!-- HomePage -->
    <HomePage></HomePage>
    <!-- Experiments -->
    <ExperimentsPage ref="experiment"></ExperimentsPage>
    <examplesPage ref="examples"></examplesPage>
    <ContactPage></ContactPage>
    <!-- FooterPart -->
    <BibtexView></BibtexView>
    <FooterPart></FooterPart>
  </div>
</template>

<script>
// @ is an alias to /src
import DropMenu from "@/components/DropMenu.vue";
import TopMenu from "@/components/TopMenu.vue";
import HomePage from "@/components/HomePage.vue";
import ExperimentsPage from "@/components/ExperimentsPage.vue";
// import ThirdPart from "@/components/ThirdPart.vue";
import FooterPart from "@/components/FooterPart.vue";
import BibtexView from "@/components/BibtexView.vue";
import ContactPage from "@/components/ContactPage.vue";
import examplesPage from "@/components/examplesPage.vue";

export default {
  name: "HomeView",
  components: {
    TopMenu,
    HomePage,
    ExperimentsPage,
    // ThirdPart,
    DropMenu,
    FooterPart,
    BibtexView,
    ContactPage,
    examplesPage,
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    // changeTopMenu() {
    //   let topMenu = this.$refs.TopMenu.$refs.topItem;
    //   // 监听滚动事件
    //   window.addEventListener("scroll", function () {
    //     // 页面可视区域的高度
    //     const windowHeight = window.innerHeight;
    //     // 整个页面的高度（包括滚动部分）
    //     const documentHeight = document.documentElement.scrollHeight;
    //     // 当前滚动位置
    //     const scrollPosition = window.scrollY;
    //     // 如果滚动到页面底部
    //     if (scrollPosition + windowHeight >= documentHeight) {
    //       // 修改背景颜色为黑色
    //       topMenu.style.transition = `0.5s`;
    //       topMenu.style.backgroundColor = "rgba(0, 0, 0, 1)";
    //     } else {
    //       // 否则背景颜色为透明
    //       topMenu.style.transition = `0.5s`;
    //       topMenu.style.backgroundColor = "transparent";
    //     }
    //   });
    // },
  },
};
</script>

<style>
.el-dropdown-link {
  cursor: pointer;
  /* color: #409eff; */
}
.el-icon-arrow-down {
  font-size: 12px;
  color: #409eff;
  font-weight: bold;
}
</style>
